import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const AngelsPage = () => {
  const [visibleSections, setVisibleSections] = useState(0);
  const [copiedEmail, setCopiedEmail] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisibleSections(prev => {
        if (prev >= 25) { clearInterval(timer); return prev; }
        return prev + 1;
      });
    }, 180);
    return () => clearInterval(timer);
  }, []);

  const fadeIn = (index) => ({
    opacity: visibleSections >= index ? 1 : 0,
    transform: visibleSections >= index ? 'translateY(0)' : 'translateY(20px)',
    transition: 'all 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
  });

  const copyManifesto = () => {
    const el = document.getElementById('manifesto-corpo');
    if (el) {
      navigator.clipboard.writeText(el.innerText);
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 3000);
    }
  };

  const networks = [
    { nome: 'Italian Angels for Growth (IAG)', desc: '600+ membri, 125+ deal chiusi, 550M+ investiti', url: 'https://www.italianangels.net', sede: 'Milano' },
    { nome: 'Club degli Investitori', desc: '400+ business angel, premio annuale BA dell\'Anno', url: 'https://www.clubdeglinvestitori.it', sede: 'Torino' },
    { nome: 'IBAN — Italian Business Angel Network', desc: 'Rete nazionale, 33 gruppi, 1.600+ angel attivi', url: 'https://www.iban.it', sede: 'Roma' },
    { nome: 'Angels 4 Women', desc: 'Dedicato a imprese al femminile', url: '', sede: 'Italia' },
    { nome: 'Italian Angels for Biotech', desc: 'Focus biotech e life science', url: '', sede: 'Italia' },
    { nome: 'Impact Hub Milano', desc: 'Incubatore imprenditoria sociale', url: 'https://milan.impacthub.net', sede: 'Milano' },
    { nome: 'Impact Hub Firenze', desc: 'Innovazione sociale in Toscana', url: 'https://florence.impacthub.net', sede: 'Firenze' },
    { nome: 'SocialFare', desc: 'Primo centro italiano innovazione sociale', url: 'https://socialfare.org', sede: 'Torino' },
    { nome: 'FabriQ', desc: 'Incubatore comunale progetti sociali/ambientali', url: '', sede: 'Milano' },
    { nome: 'Fondazione Intesa Sanpaolo', desc: 'Contributi per progetti utilita sociale — Bando 2026 aperto', url: '', sede: 'Torino' },
  ];

  return (
    <main data-testid="angels-page" className="min-h-screen pt-20 pb-16 bg-black text-white">
      <div className="max-w-3xl mx-auto px-6">

        {/* Header */}
        <div style={fadeIn(0)} className="text-center mb-14">
          <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-zinc-600 mb-4">
            MANIFESTO PER BUSINESS ANGEL E INCUBATORI
          </p>
          <div className="w-16 h-[1px] bg-purple-500/30 mx-auto mb-6" />
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-3">
            Investite nel Territorio
          </h1>
          <p className="text-purple-400 font-mono text-sm mb-2">
            &lt;/AI_covo.tech&gt;<sup className="text-[8px]">&reg;</sup> — Impresa Sociale
          </p>
          <p className="text-zinc-500 text-xs max-w-md mx-auto">
            Email/Manifesto pronto da inviare a tutti i Business Angel d'Italia e incubatori sociali.
            Personalizza i campi _______ e invia.
          </p>
        </div>

        {/* Rete target */}
        <div style={fadeIn(1)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-purple-400 mb-6">
            A CHI INVIARE — RETE ITALIANA BA E INCUBATORI
          </p>
          <div className="space-y-2">
            {networks.map((n, i) => (
              <div key={i} className="flex items-center justify-between p-3 border border-zinc-800 hover:border-purple-500/30 transition-colors">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="text-white font-bold text-xs">{n.nome}</p>
                    <span className="text-zinc-600 text-[10px] font-mono">{n.sede}</span>
                  </div>
                  <p className="text-zinc-500 text-[10px] mt-0.5">{n.desc}</p>
                </div>
                {n.url && (
                  <a href={n.url} target="_blank" rel="noopener noreferrer" 
                     className="text-purple-400 text-[10px] font-mono ml-3 hover:text-purple-300 flex-shrink-0">
                    SITO
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* EMAIL / MANIFESTO */}
        <div style={fadeIn(3)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-purple-400 mb-6">
            EMAIL / MANIFESTO — PRONTA DA INVIARE
          </p>

          <div className="bg-[#0A0A0A] border border-purple-500/20 p-6 sm:p-8" id="manifesto-corpo">

            {/* Oggetto */}
            <div className="mb-6 pb-4 border-b border-zinc-800">
              <p className="text-zinc-500 text-[10px] font-mono">OGGETTO:</p>
              <p className="text-white font-bold text-sm mt-1">
                Opportunita di Investimento ad Impatto Sociale — Hub Digitale &lt;/AI_covo.tech&gt;® | Toscana
              </p>
            </div>

            {/* Destinatario */}
            <div className="mb-6 pb-4 border-b border-zinc-800">
              <p className="text-zinc-500 text-[10px] font-mono mb-2">A:</p>
              <p className="text-white text-xs">
                Spett.le <span className="text-purple-400 font-bold">_______________________________</span>
              </p>
              <p className="text-zinc-400 text-xs">
                Alla cortese attenzione di <span className="text-purple-400 font-bold">_______________________________</span>
              </p>
            </div>

            {/* Corpo */}
            <div className="space-y-4 text-xs text-zinc-300 leading-relaxed">

              <p>Gentilissimo/a <span className="text-purple-400 font-bold">_______________________________</span>,</p>

              <p>
                mi permetto di contattarVi perché credo che 
                <span className="text-purple-400 font-bold"> _______________________________ </span>
                condivida una verita spesso ignorata nell'ecosistema dell'innovazione italiana: 
                <span className="text-white font-bold">il futuro non si costruisce solo nelle grandi citta</span>.
              </p>

              <p>
                Vi scrivo dalla Valdelsa, Toscana — un territorio di 73.000 abitanti tra Siena e Firenze, 
                dove stiamo costruendo qualcosa che non esiste ancora: un 
                <span className="text-[#00FF41] font-bold"> Hub Digitale Sociale</span> che unisce 
                intelligenza artificiale, formazione, inclusione e rigenerazione urbana.
              </p>

              {/* Chi siamo */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">CHI SIAMO</p>
                <p>
                  <span className="text-[#00FF41] font-bold">&lt;/AI_covo.tech&gt;®</span> e una 
                  <span className="text-white font-bold"> Cooperativa Sociale — Impresa Sociale</span> (D.Lgs. 112/2017) 
                  iscritta al RUNTS. Non siamo un'idea su un pitch deck. 
                  <span className="text-[#00FF41] font-bold"> La piattaforma digitale e già operativa</span>.
                </p>
                <ul className="mt-3 space-y-1.5 pl-4">
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">&#8250;</span>
                    <span><span className="text-white font-bold">Piattaforma web funzionante</span> — AI chat, podcast, video formativi, archivio gamificato, piano editoriale social</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">&#8250;</span>
                    <span><span className="text-white font-bold">Formazione AI e digitale</span> — Corsi, coaching, certificazioni Google per giovani e adulti</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">&#8250;</span>
                    <span><span className="text-white font-bold">Sportello psicologico "Mentor"</span> — Supporto integrato con AI per la comunità</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">&#8250;</span>
                    <span><span className="text-white font-bold">Doposcuola digitale e sportivo</span> — Per le generazioni Alpha, Z e oltre</span>
                  </li>
                </ul>
              </div>

              {/* Il problema */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">IL PROBLEMA CHE RISOLVIAMO</p>
                <p>
                  L'Italia investe in innovazione concentrando risorse su Milano, Roma, Torino. 
                  I <span className="text-white font-bold">territori intermedi</span> — quelli tra 5.000 e 30.000 abitanti, 
                  che rappresentano la maggioranza del Paese — restano indietro. 
                  Non per mancanza di talento, ma di <span className="text-[#FFD700] font-bold">infrastrutture digitali e sociali</span>.
                </p>
                <p className="mt-3">
                  La Valdelsa ha capannoni vuoti, giovani che emigrano, anziani isolati digitalmente. 
                  Noi trasformiamo uno spazio inutilizzato in un 
                  <span className="text-[#00FF41] font-bold"> centro nevralgico di competenze digitali e coesione sociale</span>.
                </p>
              </div>

              {/* I numeri */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">I NUMERI</p>
                <div className="grid grid-cols-2 gap-3 mt-3">
                  <div className="border border-zinc-800 p-3 text-center">
                    <p className="text-xl font-black text-[#00FF41]">88.750</p>
                    <p className="text-zinc-500 text-[10px] font-mono">BUDGET ANNUALE (EUR)</p>
                  </div>
                  <div className="border border-zinc-800 p-3 text-center">
                    <p className="text-xl font-black text-white">73.200</p>
                    <p className="text-zinc-500 text-[10px] font-mono">BACINO 5 COMUNI</p>
                  </div>
                  <div className="border border-zinc-800 p-3 text-center">
                    <p className="text-xl font-black text-[#FFD700]">3</p>
                    <p className="text-zinc-500 text-[10px] font-mono">PROFESSIONISTI</p>
                  </div>
                  <div className="border border-zinc-800 p-3 text-center">
                    <p className="text-xl font-black text-purple-400">2.500</p>
                    <p className="text-zinc-500 text-[10px] font-mono">SOCI OBIETTIVO 10 ANNI</p>
                  </div>
                </div>
              </div>

              {/* Agevolazioni */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">AGEVOLAZIONI FISCALI PER INVESTITORI</p>
                <p>
                  In quanto <span className="text-white font-bold">Impresa Sociale</span> (D.Lgs. 112/2017), 
                  chi investe nel nostro progetto accede a:
                </p>
                <ul className="mt-3 space-y-2 pl-4">
                  <li className="flex items-start gap-2">
                    <span className="text-[#FFD700] font-bold">+</span>
                    <span><span className="text-[#FFD700] font-bold">Detrazione IRPEF 30%</span> per persone fisiche (max 1.000.000 EUR/anno) — investimento min. 5 anni</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FFD700] font-bold">+</span>
                    <span><span className="text-[#FFD700] font-bold">Deduzione IRES 30%</span> per società (max 1.800.000 EUR) — investimento min. 5 anni</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FFD700] font-bold">+</span>
                    <span><span className="text-[#FFD700] font-bold">Erogazioni liberali</span>: deducibili fino al 10% del reddito complessivo dichiarato (eccedenze riportabili 4 anni)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#FFD700] font-bold">+</span>
                    <span>Dal 2026: <span className="text-[#FFD700] font-bold">utili non imponibili</span> se reinvestiti (DL 84/2025)</span>
                  </li>
                </ul>
              </div>

              {/* Cosa chiediamo */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">COSA CHIEDIAMO</p>
                <p>Non chiediamo milioni. Chiediamo:</p>
                <ul className="mt-3 space-y-2 pl-4">
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">1.</span>
                    <span><span className="text-white font-bold">Un investimento</span> (anche di 5.000 - 25.000 EUR) per coprire il primo anno operativo</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">2.</span>
                    <span><span className="text-white font-bold">Mentorship</span> — Se avete esperienza in scaling di imprese sociali, education tech o community building</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">3.</span>
                    <span><span className="text-white font-bold">Network</span> — Presentateci a chi potrebbe credere in questo modello</span>
                  </li>
                </ul>
                <div className="mt-4 p-3 bg-[#FFD700]/5 border border-[#FFD700]/10">
                  <p className="text-[#FFD700] font-bold text-xs mb-1">INTEGRAZIONE BANCARIA</p>
                  <p>Ogni socio AI_COVO avra una convenzione per aprire un conto corrente online presso la banca partner (modello Alphabet/Fideuram). La Cooperativa avra C/C con IBAN dedicato collegato al circuito bancario — tutte le transazioni (donazioni, iscrizioni, gateway) transiteranno su questo conto.</p>
                </div>
              </div>

              {/* Perché voi */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">PERCHE PROPRIO VOI</p>
                <p>
                  Gentilissimo/a <span className="text-purple-400 font-bold">_______________________________</span>,
                </p>
                <p className="mt-2">
                  <span className="text-purple-400 font-bold">_______________________________</span> ha dimostrato 
                  con i propri investimenti una sensibilita unica verso 
                  <span className="text-purple-400 font-bold"> _______________________________ </span>
                  (innovazione sociale / impatto territoriale / education tech / deep tech applicato al sociale / 
                  startup early-stage).
                </p>
                <p className="mt-2">
                  Il nostro progetto unisce tecnologia all'avanguardia (AI, piattaforme digitali) con impatto sociale 
                  misurabile in un territorio che ha bisogno esattamente di questo tipo di intervento.
                </p>
              </div>

              {/* Call to action */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">IL PASSO SUCCESSIVO</p>
                <p>
                  Vi chiediamo <span className="text-white font-bold">30 minuti</span> — una call o un incontro. 
                  Vi mostreremo la piattaforma funzionante, il business plan, i numeri, e il capannone 
                  che diventerà il primo Hub Digitale Sociale della Toscana rurale.
                </p>
                <p className="mt-3">
                  La piattaforma e visitabile adesso, in tempo reale.
                </p>
              </div>

              {/* Chiusura */}
              <div className="my-6 pt-4 border-t border-zinc-800">
                <p className="text-zinc-300 mb-4">
                  Sappiamo che ricevete decine di proposte al giorno. Ma quante vengono dalla Toscana rurale? 
                  Quante hanno gia un prodotto funzionante? Quante costano meno di un appartamento?
                </p>
                <p className="text-white font-bold">
                  Noi non vi chiediamo di scommettere. Vi chiediamo di guardare.
                </p>
              </div>

              {/* Firma */}
              <div className="mt-6 pt-4 border-t border-zinc-800">
                <p>Con rispetto e determinazione,</p>
                <p className="mt-3 text-white font-bold">[Nome Cognome]</p>
                <p className="text-zinc-400">Presidente — Cooperativa Sociale &lt;/AI_covo.tech&gt;®</p>
                <p className="text-zinc-500 mt-1">[Email] | [Telefono]</p>
                <p className="text-zinc-500 mt-1">[Link piattaforma]</p>
                <p className="text-zinc-600 text-[10px] mt-3 italic">
                  Allegati consigliati: Executive Summary (1 pag.), Business Plan triennale, Statuto Cooperativa, 
                  Visura RUNTS, Screenshot piattaforma operativa
                </p>
              </div>
            </div>
          </div>

          {/* Pulsante copia */}
          <button
            data-testid="copy-manifesto-btn"
            onClick={copyManifesto}
            className="mt-4 w-full font-mono text-xs text-center py-3 border transition-all duration-300"
            style={{
              borderColor: copiedEmail ? '#00FF41' : '#A855F7',
              color: copiedEmail ? '#00FF41' : '#A855F7',
              backgroundColor: copiedEmail ? 'rgba(0,255,65,0.05)' : 'transparent',
            }}
          >
            {copiedEmail ? 'COPIATO NEGLI APPUNTI' : 'COPIA TESTO MANIFESTO'}
          </button>
        </div>

        {/* Checklist invio */}
        <div style={fadeIn(7)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-purple-400 mb-6">
            CHECKLIST PRIMA DI INVIARE
          </p>
          <div className="space-y-2">
            {[
              'Compila tutti i campi _______ con nome destinatario, azienda e referenza specifica',
              'Allega: Executive Summary (1 pagina), Business Plan triennale',
              'Allega: Statuto Cooperativa + Visura RUNTS',
              'Allega: 2-3 screenshot della piattaforma operativa',
              'Personalizza la sezione "Perché proprio voi" con un investimento/progetto specifico del BA',
              'Invia da email professionale (non Gmail personale)',
              'Follow-up telefonico dopo 5-7 giorni lavorativi',
              'Se nessuna risposta dopo 14 gg, secondo follow-up via LinkedIn',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3 p-3 border border-zinc-800">
                <div className="w-5 h-5 border border-purple-500/30 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-purple-400 text-[10px] font-mono">{i + 1}</span>
                </div>
                <p className="text-zinc-300 text-xs">{item}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Link di navigazione */}
        <div style={fadeIn(9)} className="mb-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <Link to="/crowdfunding" className="block text-center font-mono text-xs text-[#00FF41] border border-[#00FF41]/30 py-4 hover:bg-[#00FF41]/10 transition-colors">
              CAMPAGNA CROWDFUNDING
            </Link>
            <Link to="/strategia" className="block text-center font-mono text-xs text-[#FFD700] border border-[#FFD700]/30 py-4 hover:bg-[#FFD700]/10 transition-colors">
              STRATEGIA COMPLETA
            </Link>
            <Link to="/chiantibanca" className="block text-center font-mono text-xs text-white border border-zinc-600 py-4 hover:bg-zinc-800 transition-colors">
              PROPOSTA CHIANTIBANCA
            </Link>
            <Link to="/dona" className="block text-center font-mono text-xs text-black bg-[#00FF41] py-4 hover:bg-[#33FF66] transition-colors">
              DONA ORA
            </Link>
          </div>
        </div>

        {/* Footer */}
        <div style={fadeIn(11)} className="text-center text-zinc-600 text-xs border-t border-zinc-900 pt-8 pb-4">
          <p className="text-zinc-500 font-mono text-[10px] mb-2">
            &lt;/AI_COVO.tech&gt;® — Manifesto Business Angel & Incubatori
          </p>
          <p>Colle Val d'Elsa — Valdelsa — Toscana — Italia</p>
        </div>

      </div>
    </main>
  );
};

export default AngelsPage;
